import React from 'react'
import Navbar from '../components/Navbar';
import DemoHead from '../components/DemoHead';
import DemoForm from '../components/DemoForm';
import Footer from '../components/Footer';

function Demo() {
  return (
    <>
    <Navbar/>
    <div className='spacer'></div>
    <DemoHead/>
    <DemoForm/>
    <Footer/>
    </>
    
  )
}

export default Demo